import { call, put, takeLatest } from "redux-saga/effects";
import {
GET_CALENDARYEAR,
ADD_CALENDARYEAR,
UPDATE_CALENDARYEAR,
DELETE_CALENDARYEAR,
GET_CALENDARYEAR_SUCCESS,
ADD_CALENDARYEAR_SUCCESS,
UPDATE_CALENDARYEAR_SUCCESS,
DELETE_CALENDARYEAR_SUCCESS
} from "../../redux/actions/actionType";
import api from "../../apis/api";

// api function.
function getCalendarYearApi()  {
    // api for get review list
   const response = api.dbcalendar().GetCalanderYearList();
    return response;
  }
  function addCalendarYearApi(formData) {
    // api for add  review.
   const res= api.dbCalendarYear().AddEditCalanderYear(formData);
   return res;
  }
  function updateCalendarYearApi(formData) {
    // api for update  review.
    const res= api.dbCalendarYear().AddEditCalanderYear(formData);
    return res;
  }
  function delCalendarYearApi(formData) {
    // api for update  review.
    const res= api.dbCalendarYear().DeleteCalanderYear(formData);
    return res;
  }
  // function deleteReviewApi(delId) {
  //   // api for delete  review.
  //   const response = api.dbReviewRating().DeleteRating(delId);
  //   return response;
  // }
  
export function* handleGetCalendarYear() {
    try {
      const response = yield call(getCalendarYearApi);
      yield put({ type: GET_CALENDARYEAR_SUCCESS, payload: response.data });
    } catch (error) {
       
    }
  }
  export function* handleAddCalendarYear({ payload }) {
    try {
      yield call(addCalendarYearApi, payload);
      yield put({ type: ADD_CALENDARYEAR_SUCCESS, payload: payload });
      const response = yield call(getCalendarYearApi);
      yield put({ type: GET_CALENDARYEAR_SUCCESS, payload: response.data });
    } catch (error) {
       
    }
  }
  export function* handleUpdateCalendarYear({ payload }) {
    try {
      let formData = payload;
      yield call(updateCalendarYearApi, formData);
      yield put({ type: UPDATE_CALENDARYEAR_SUCCESS, payload: formData });
      const response = yield call(getCalendarYearApi);
      yield put({ type: GET_CALENDARYEAR_SUCCESS, payload: response.data });
    } catch (error) {
       
    }
  }
  export function* handleDeletedelCalendarYear({ payload }) {
    try {
      yield call(delCalendarYearApi, payload);
      yield put({ type: DELETE_CALENDARYEAR_SUCCESS, payload: payload });
      const response = yield call(getCalendarYearApi);
      yield put({ type: GET_CALENDARYEAR_SUCCESS, payload: response.data });
    } catch (error) {
       
    }
  }
  
  // watach function.
  export function* CalendarYearWatchFun() {
    yield takeLatest(GET_CALENDARYEAR, handleGetCalendarYear);
    yield takeLatest(ADD_CALENDARYEAR, handleAddCalendarYear);
    yield takeLatest(UPDATE_CALENDARYEAR, handleUpdateCalendarYear);
    yield takeLatest(DELETE_CALENDARYEAR, handleDeletedelCalendarYear);
  }